import { ReactComponent as Icon } from './categoryIcon.svg'
import { theme } from '@ss/meta-core-components'
import React from 'react'
import { config } from '../../../config'

interface Props {
  ariaLabel?: string
  role?: string
}
export const CategoryIcon: React.FC<Props> = ({
  ariaLabel = 'category',
  role = 'icon',
}) => {
  return (
    <Icon
      aria-label={ariaLabel}
      role={role}
      data-cy={'category-icon'}
      fill={
        theme.type === 'dark' ? config.iconColorDark : config.iconColorLight
      }
    />
  )
}
